import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "flex mx-6 space-x-6 pt-4" }
const _hoisted_3 = { class: "flex-1 font-medium" }
const _hoisted_4 = { class: "text-lg my-auto" }
const _hoisted_5 = { class: "text-right mr-6 w-80" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_NewReconciliationModal = _resolveComponent("NewReconciliationModal")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_EditReconciliationModal = _resolveComponent("EditReconciliationModal")!
  const _component_CustomTable = _resolveComponent("CustomTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('views.feed.reconciliations.table.header')), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_SearchInput, {
          value: _ctx.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          label: _ctx.$t('views.feed.reconciliations.table.searchFieldLabel')
        }, null, 8, ["value", "label"])
      ]),
      _createVNode(_component_NewReconciliationModal, null, {
        default: _withCtx(({ open }) => [
          _createVNode(_component_AddButton, {
            "text-class": "font-medium",
            onClick: open
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.feed.reconciliations.table.addButtonLabel')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_CustomTable, {
      headers: _ctx.headers,
      items: _ctx.filteredItems
    }, {
      from_status_date: _withCtx(({ item, getHeaderClass, getWidth, header }) => [
        (_openBlock(), _createElementBlock("td", {
          key: header.value,
          class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words flex`),
          style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.from_status_date)), 1)
        ], 6))
      ]),
      to_status_date: _withCtx(({ item, getHeaderClass, getWidth, header }) => [
        (_openBlock(), _createElementBlock("td", {
          key: header.value,
          class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words flex`),
          style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.to_status_date)), 1)
        ], 6))
      ]),
      amount_kg: _withCtx(({ item, getHeaderClass, getWidth, header }) => [
        (_openBlock(), _createElementBlock("td", {
          key: header.value,
          class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words flex`),
          style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatAmount(item.amount_kg)), 1)
        ], 6))
      ]),
      actions: _withCtx(({ item, getHeaderClass, getWidth, header }) => [
        (_openBlock(), _createElementBlock("td", {
          key: header.value,
          class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words flex`),
          style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
        }, [
          _createVNode(_component_EditReconciliationModal, { reconciliation: item }, {
            default: _withCtx(({ open }) => [
              _createElementVNode("button", {
                type: "button",
                class: "p-2 -mr-2",
                onClick: open
              }, [
                _createVNode(_component_Icon, {
                  class: "h-3 w-3 cursor-pointer",
                  src: _ctx.IconSource.Right
                }, null, 8, ["src"])
              ], 8, _hoisted_6)
            ]),
            _: 2
          }, 1032, ["reconciliation"])
        ], 6))
      ]),
      _: 1
    }, 8, ["headers", "items"])
  ]))
}